/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Help_DeskInputs */

const en_admin_dashboard_help_desk = /** @type {(inputs: Admin_Dashboard_Help_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help Desk`)
};

const de_admin_dashboard_help_desk = /** @type {(inputs: Admin_Dashboard_Help_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help-Desk`)
};

const es_admin_dashboard_help_desk = /** @type {(inputs: Admin_Dashboard_Help_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de ayuda`)
};

const fr_admin_dashboard_help_desk = /** @type {(inputs: Admin_Dashboard_Help_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistance`)
};

const nl_admin_dashboard_help_desk = /** @type {(inputs: Admin_Dashboard_Help_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helpdesk`)
};

const it_admin_dashboard_help_desk = /** @type {(inputs: Admin_Dashboard_Help_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help Desk`)
};

const pt_br2_admin_dashboard_help_desk = /** @type {(inputs: Admin_Dashboard_Help_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Central de ajuda`)
};

const pl_admin_dashboard_help_desk = /** @type {(inputs: Admin_Dashboard_Help_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help Desk`)
};

const hu_admin_dashboard_help_desk = /** @type {(inputs: Admin_Dashboard_Help_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ügyfélszolgálat`)
};

const ro_admin_dashboard_help_desk = /** @type {(inputs: Admin_Dashboard_Help_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help Desk`)
};

/**
* | output |
* | --- |
* | "Help Desk" |
*
* @param {Admin_Dashboard_Help_DeskInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_help_desk = /** @type {((inputs?: Admin_Dashboard_Help_DeskInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Help_DeskInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_help_desk(inputs)
	if (locale === "de") return de_admin_dashboard_help_desk(inputs)
	if (locale === "es") return es_admin_dashboard_help_desk(inputs)
	if (locale === "fr") return fr_admin_dashboard_help_desk(inputs)
	if (locale === "nl") return nl_admin_dashboard_help_desk(inputs)
	if (locale === "it") return it_admin_dashboard_help_desk(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_help_desk(inputs)
	if (locale === "pl") return pl_admin_dashboard_help_desk(inputs)
	if (locale === "hu") return hu_admin_dashboard_help_desk(inputs)
	return ro_admin_dashboard_help_desk(inputs)
});
export { admin_dashboard_help_desk as "admin.dashboard.help_desk" }